// ─────────────────────────────────────────────────────────
// layouts/AuthLayout.tsx — Login / register wrapper
// Redirects to /dashboard if already authenticated
// ─────────────────────────────────────────────────────────
import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore }     from '@/store/authStore'

export default function AuthLayout() {
  const { user, isLoading } = useAuthStore()

  // While auth resolves, render nothing (RequireAuth handles the loader)
  if (isLoading) return null

  // Already logged in — go to dashboard
  if (user) return <Navigate to="/dashboard" replace />

  return (
    <div style={{
      minHeight:      '100vh',
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      background:     'var(--color-sf)',
      padding:        20,
      width:          '100%',
    }}>
      <Outlet />
    </div>
  )
}
